<template>
    <div class="paper-card flex flex-col gap-4 rounded border border-solid border-grey-40 bg-white px-6 py-4">
        <div class="flex items-center gap-4">
            <span class="shrink-0 text-xl font-semibold text-black">{{ title }} </span>

            <div class="th-tooltip" :data-tip="t('patentMatrixTrendTip')">
                <PtIcon icon="SolidInfo" class="fill-grey-55 text-2xl" />
            </div>

            <i class="grow"></i>

            <button @click="downloadChartAsImage" :disabled="disableUI" class="th-btn th-btn-plain shrink-0">
                <PtIcon class="th-btn-icon fill-grey-450 text-2xl" icon="SolidExport" />
                <span> {{ t('download') }} </span>
            </button>
        </div>

        <div class="flex gap-3">
            <button
                @click="changeEfficiencyType(PATENT_EFFICIENCY_TYPE.KEY_EFFICIENCY)"
                class="th-btn th-btn-secondary border-none text-grey-450"
                :class="{ 'bg-blue-40 text-primary hover:bg-blue-40': efficiencyType === PATENT_EFFICIENCY_TYPE.KEY_EFFICIENCY }"
            >
                {{ t('patentTrend.keyEfficiency') }}
            </button>
            <button
                @click="changeEfficiencyType(PATENT_EFFICIENCY_TYPE.ALL_EFFICIENCY)"
                class="th-btn th-btn-secondary border-none text-grey-450"
                :class="{ 'bg-blue-40 text-primary hover:bg-blue-40': efficiencyType === PATENT_EFFICIENCY_TYPE.ALL_EFFICIENCY }"
            >
                {{ t('patentTrend.allEfficiency') }}
            </button>
        </div>

        <div class="h-[448px]">
            <BIChart
                ref="patentTrendMatrixChart"
                :chartKey="chartKey"
                :isLoading="isFetchLoading"
                :configTaskFunc="chartConfig"
                :dataTaskFunc="getPatentMatrixChartData"
                @click="handleDrillDown"
                class="h-full w-full"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { usePatentMatrix } from '@/composables/use-patent-matrix'
import BIChart from '@/components/BIChart.vue'
import { PATENT_EFFICIENCY_TYPE } from '@/types'
import { ref } from 'vue'
import { PtIcon } from 'patsnap-biz'
import '@patsnap-ui/icon/assets/solid/export.svg'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const patentTrendMatrixChart = ref<{
    generateChartImage: () => Promise<string>
    drawChart: () => void
    isChartLoaded: () => boolean
    isEmptyChart: boolean
}>()

const {
    disableUI,
    chartKey,
    chartConfig,
    isFetchLoading,
    getPatentMatrixChartData,
    changeEfficiencyType,
    efficiencyType,
    downloadChartAsImage,
    handleDrillDown,
    title,
} = usePatentMatrix(patentTrendMatrixChart);

</script>
